module.exports = __webpack_public_path__ + "static/media/sbf-upzoning-press.083a2422.png";